import { forwardRef } from 'react';

import { Group, Spacing } from '@vkontakte/vkui';
import { AnimatePresence, motion } from 'framer-motion';

import header from './../../../../../../../images/mobile/header.png';
import { PredictionContentProps } from './types';
import { Footer } from '../../../../../../../components/Footer/Footer';
import { ContentCard } from '../ContentCard';


export const PredictionContent = forwardRef<HTMLDivElement, PredictionContentProps>(({
  handleOnGetTemperament,
  handleOnGetFriendTemperament,
  delayAnimation = 0,
}, ref) => {
  return (
    <div ref={ref}>
      <Group>

        <div style={{ margin: '16px 32px 0' }} >

          <ContentCard
            title="Узнать свой профессиональный тип"
            text="Проверьте бесплатно с помощью искусственного интеллекта, что Ваша страница говорит о Вас"
            buttonText="Узнать профессиональный тип"
            onClick={handleOnGetTemperament}
          />

          <Spacing size={30}/>
          <div style={{ margin: '0 18px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <AnimatePresence>
              <motion.div
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                animate={{ scale: [0.7, 1.06, 1] }}
                transition={{
                  duration: 0.6,
                  delay: delayAnimation,
                }}
              >
                <img style={{ width:'85%' }} src={header} alt=''/>
              </motion.div>
            </AnimatePresence>
          </div>
          <Spacing size={30}/>
          <ContentCard
            title="Узнать профессиональный тип других"
            text="Оплатите голосами и узнайте, что страницы людей говорят об их профессиональном типе"
            buttonText="Узнать профессиональный тип"
            onClick={handleOnGetFriendTemperament}
          />
          <Footer/>
          <Spacing size={30}/>
        </div>
      </Group>
    </div>
  );
});
